import ErrorResponse from '../api/types/ErrorResponse';

import ApiService from 'api/services/AuthService';
import User from 'entities/User';
import errorResponseNotification from 'helpers/errorResponseNotification';

class AuthService {
	api: ApiService;
	user: null | User = null;

	constructor() {
		this.api = new ApiService();
	}

	async me() {
		await this.api.me((response) => {
			this.user = new User();
			this.user.setId(response.id);
			this.user.setName(response.name);
		});
	}

	async login(name: string, password: string) {
		await this.api.login(
			name,
			password,
			(response) => {
				this.user = new User();
				this.user.setId(response.id);
				this.user.setName(response.name);
			},
			(response: ErrorResponse) => {
				errorResponseNotification(response);
			},
		);
	}

	async logout() {
		await this.api.logout(() => {
			this.user = null;
		});
	}

	getUser(): User | null {
		return this.user;
	}
}

export default AuthService;
